import React from 'react'
import Navigation from './navigation'
import Footer from './footer'
import './mobile-navigation.scss'

class MobileNavigation extends React.Component {
  render() {
    const { mobileNavClass, footerData } = this.props;

    return (
      <div className={`mobile-navigation ${mobileNavClass}`}>
        <button className="toggle-nav close" onClick={this.handleClick.bind(this)}>
          <span> - </span>
        </button>

        <Navigation isMobile linkData={this.props.linkData} />

        <Footer footerData={footerData} />
      </div>
    )
  }

  handleClick() {
    const { toggleMobileNav } = this.props;

    toggleMobileNav();
  }
}


export default MobileNavigation



// WEBPACK FOOTER //
// ./src/components/mobile-navigation.js